<template>
    <div id="groupList" class="background-ash pl20 pr20 pb20" v-loading="loading">
        <div class="search_list background-white">
		   <ul class="lists">
                <li>
                    <span>分组名称</span>
                    <el-input size="small" class="width180" @keyup.native.enter="pageNo = 1, getList()" v-model="search.groupName" placeholder="请输入"></el-input>
                </li>
				<li>
                    <span>账号</span>
                    <el-input size="small" class="width130" @keyup.native.enter="pageNo = 1, getList()" v-model="search.account" placeholder="请输入"></el-input>
                </li>
				<li>
                    <span>企业名称</span>
                    <el-input size="small" class="width130" @keyup.native.enter="pageNo = 1, getList()" v-model="search.companyNameLike" placeholder="请输入"></el-input>
                </li>
            </ul>
			<div class="btns" style="width:140px;">
                <el-button size="small" type="primary"  @click="pageNo = 1, getList()">搜索</el-button>
                <el-button type="primary" plain size="mini" @click="reset()">重置</el-button>
            </div>
        </div>
        <!--内容-->
        <div class="pt20 content">
            <!--表头操作-->
            <div class="watchBar">
                <div class="btns left">
                    <el-button type="primary" size="small" @click="isShowAdd = true">添加分组</el-button>
                    <el-button type="primary" size="small" @click="deleteGroup('batch')">批量删除</el-button>
                    <el-button size="small"  type="primary" plain @click="batchAdd()">批量添加分组账号</el-button>
                    <el-button size="small"  type="primary" plain @click="batchRemove()">批量移出分组账号</el-button>
                    <span class="ml10 color-606266">同一个分组的账号，线下比价和自动比价的数据将会共享</span>
                </div>
            </div>
            <!--表格-->
            <div class="tab">
                <el-table ref="checkList" row-key="id" @selection-change="changeCheckId" size="mini" :data="list" tooltip-effect="dark" height="100%">
                    <el-table-column type="selection" width="50" :reserve-selection="true"></el-table-column>
                    <el-table-column label="分组名称" prop="name"></el-table-column>
                    <el-table-column label="账号数量" width="140" >
                        <template slot-scope="scope">
                            <router-link v-if="scope.row.accountNum>0" class="to-detail" :to="'/userList?groupId='+scope.row.id">{{ scope.row.accountNum }}</router-link>
                            <span v-else>0</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status==='ENABLED'">启用</span>
                            <span v-else>禁用</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="创建人" prop="createBy"></el-table-column>
                    <el-table-column label="创建时间">
                        <span slot-scope="scope">{{ scope.row.gmtCreate | data}}</span>
                    </el-table-column>
                    <el-table-column label="操作" width="320" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" @click="updateGroup(scope.row)">编辑</el-button>
                            <el-button type="text" @click="deleteGroup(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page background-white text-right p20">
                <el-pagination class="pr20 pb20 background-white text-right pages" @size-change="pageSizeChange" @current-change="pageNoChange" :current-page="pageNo" :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
            </div>
        </div>
        <!-- 添加分组 -->
        <el-dialog title="添加分组" :visible.sync="isShowAdd" width="400px" :close-on-click-modal="false">
            <div class="pl20 pr20 pb20">
                <ul class="list color-606266 pl20">
                    <li class="flex pt10 pb10">
                        <p class="name">
                            <span class="color-red">*</span>分组名称：
                        </p>
                        <div class="f1 pl10">
                            <el-input size="mini" v-model="addParam.name" maxlength="12" style="width: 220px;" clearable placeholder="请输入任务名称"></el-input>
                        </div>
                    </li>
                    <!-- <li class="flex mr10 pb10 pt10">
                        <p class="name">状态：</p>
                        <div class="f1 pl10">
                            <el-radio-group v-model="addParam.status">
                                <el-radio label="ENABLED">启用</el-radio>
                                <el-radio label="DISABLED">禁用</el-radio>
                            </el-radio-group>
                        </div>
                    </li> -->
                    <li class="flex mr10 pt10">
                        <p class="name"></p>
                        <div class="f1 pl10">
                            <el-button type="primary" plain size="mini" @click="isShowAdd = !isShowAdd">取消</el-button>
                            <el-button type="primary" size="mini" @click="addSave()">保存</el-button>
                        </div>
                    </li>
                </ul>
            </div>
        </el-dialog>
        <!-- 批量添加/删除分组 -->
        <el-dialog :title="optType == 1 ? '批量添加分组帐号':'移出账号'" :visible.sync="isShowBatch" width="70%" :close-on-click-modal="false">
            <batchAdd v-if="isShowBatch" :ids="checkId" :isSearch="optType" @close="isShowBatch = false" @success=" returnBatchAccount($event)"></batchAdd>
        </el-dialog>
    </div>
</template>
<script>
import batchAdd from './batchAdd.vue'
export default {
    name: 'groupList',
    components:{
        batchAdd
    },
    data () {
        return {
            loading: false,
            search_upback: {
                groupName: '', //分组名称
                account: '', //账号
                companyNameLike: '', //企业名称
            },
            search: {},
            pageNo:1,
			pageSize:10,
            list: [],
            total: 0,
            checkId: [], //选中的分组
            isShowAdd: false, //是否显示添加分组
            addParam: {
                id: null,
                name: '',
                status: 'ENABLED'
            },
            optType: 0, //是批量设置添加还是删除：操作类型（1-增加，2-删除）
            isShowBatch: false, //批量添加或删除
        }
    },
    watch: {
        isShowAdd (val) {
            if (!val) {
                this.addParam.id = null
                this.addParam.name = '';
                this.addParam.status = 'ENABLED';
            }
        }
    },
    methods: {
        //新增
        addSave () {
            if (!this.addParam.name) {
                this.$message({message: '请输入分组名称', type: 'error'});
                return false
            }
            let options = {
                name: this.addParam.name,
                status: this.addParam.status,
                id: this.addParam.id
            }
            this.loading = true
            this.$http('post', '/admin/userGroup/save', {}, options, (status, res) => {
                this.isShowAdd = false;
                this.loading = false
                if (status) {
                    this.success('保存成功！');
                    this.getList ()
                }
            })
        },
        //编辑
        updateGroup (val) {
            this.addParam.id = val.id;
            this.addParam.name = val.name;
            this.addParam.status = val.status;
            this.isShowAdd = true;
        },
        //删除
        deleteGroup (val) {
            let ids = []
            if (val == 'batch' && this.checkId.length <= 0) {
                this.error('请选择删除的分组')
                return false
            }
            if (typeof val !== 'string') {
                ids = [val.id]
            } else {
                ids = this.checkId.map((item)=>(item.id));
            }
            console.log('ids',ids);
            this.confirm('<div>是否删除选中分组？</div><div class=\'color-red\'>若确认删除，该分组下的账号将会取消关联</div>',(index)=>{
                layer.close(index)
                this.loading = true
                this.$http('POST', '/admin/userGroup/batchDelete', {}, {ids: ids}, (status, res) => {
                    if (status) {
                        this.$refs.checkList.clearSelection()
                        this.checkId = []
                        this.success('删除成功！');
                        this.getList ()
                    }
                })
            })
        },
        //批量添加分组
        batchAdd () {
            if (this.checkId.length <= 0) {
                this.error('请选择操作的分组')
                return false
            }
            if (this.checkId.length > 1) {
                this.error('该操作只能选择一个分组')
                return false
            }
            this.optType = 1;
            this.isShowBatch = true;
        },
        //批量移出
        batchRemove () {
            if (this.checkId.length <= 0) {
                this.error('请选择操作的分组')
                return false
            }
            if (this.checkId.length > 1) {
                this.error('该操作只能选择一个分组')
                return false
            }
            this.optType = 2;
            this.isShowBatch = true;
        },
        //获取批量组件返回值(用户ID或者账号)
        returnBatchAccount (e) {
            let options = {
                groupId: this.checkId[0].id,
                userIdList: null,
                accounts: '',
                optType: this.optType
            }
            if (typeof e === 'string') {
                //说明是账号导入
                options.accounts = e
            } else {
                options.userIdList = e.map((list)=>(list.id)) //用户id集合
            }
            this.loading = true
            this.$http('POST', '/admin/userGroup/set', {}, options, (status, res) => {
                this.loading = false
                if (status) {
                    if (res.hasOwnProperty('data')) {
                        this.success('已成功设置'+res.data+'个账号');
                    } else {
                        this.success(res.message);
                    }
                    this.isShowBatch = false
                    this.$refs.checkList.clearSelection()
                    this.checkId = []
                    this.getList ()
                }
            })
        },
        //列表勾选状态改变
        changeCheckId(e) {
            this.checkId = e
        },
        pageSizeChange(val) {
            this.pageSize = val
            this.pageNo = 1
            this.getList()
        },
        pageNoChange(val) {
            this.pageNo = val
            this.getList()
        },
        reset() {
            this.search = JSON.parse(JSON.stringify(this.search_upback))
            this.pageNo = 1
            this.getList()
        },
        getList () {
            let options = {
                nameLike: this.search.groupName,
                accountLike: this.search.account,
                companyNameLike: this.search.companyNameLike,
                page: (this.pageNo-1),
                size: this.pageSize
            }
            this.loading = true
            this.$http('POST', '/admin/userGroup/page', {}, options, (status, res) => {
                this.loading = false
                if (status) {
                    if(!!res.content && res.content.length > 0) {
                        this.list = res.content;
                    }else {
                        this.list = [];
                    }
                    this.total = res.totalCount;
                }
            })
        },
    },
    mounted() {
        this.reset()
    },
}
</script>
<style scoped>
#groupList {width: 100%;height: calc(100vh - 155px);}
#groupList .content {height: calc(100% - 91px);}
#groupList .content .tab {height: calc(100% - 125px);}
#groupList >>>.el-dialog__body{padding: 0;}
.list .name{width: 80px; text-align: right;}
</style>


// WEBPACK FOOTER //
// src/views/user/groupManage/list.vue